import PageStyle from "@/styles/components/candidate-email/_index.module.scss";
import Button from "@/components/button";
import {
  InputError,
  InputText,
  Form,
  Formik,
  FormikControl,
  FormStyle,
  useRef,
  useRouter,
  useState,
  useEffect,
  Loading,
  useTranslation
} from "@/imports-files/common/common";
import { getCandidateName } from "@/actions/components/candidate-email";
import Image from "next/image";
import { ActionShareCv } from "@/actions/components/share-cv";
import {
  UNSUCCESSFUL_EMAIL_VALIDATION,
  UNSUCCESSFUL_EMAIL_VALUES,
  TEXTS,
} from "@/constants/components/unsuccessful-email-modal";
import { REVIEW_EMAIL } from "@/constants/components/review-email";
import {
  send_unsuccessful_email,
  runAutomations,
  clearRadioButtonSelection,
} from "@/imports-files/pages/clients/candidates/kanban";
import {
  ReviewEmailActions,
  useSWR,
  clearSWRCache,
} from "@/imports-files/components/review-email";
import Modal from "./common-modal/modal";
import { FormModalStyle } from "@/imports-files/components/review-email";
import { Close } from "@/imports-files/components/common-modal/common-modal";
import { addManualInterview, addManualKanbanInterview } from "@/actions/pages/clients/jobs/candidate-profile-job"

export function UnsuccessfulEmailModal(props) {
  const {t} = useTranslation()
  // --- INFO:- Clearing the SWR cache ----
  clearSWRCache("review_email_data");
  // --------------------------------------

  const [flagForRerender, setFlagForRerender] = useState(0);
  const [selectedValues, setSelectedValues] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [value, setValue] = useState("");
  const [suggestion, setSuggestion] = useState([]);
  const autosuggest_action = new ActionShareCv(setValue, setSuggestion);
  const [subject, setSubject] = useState(
    props.emailData.templates[0].subject_variables
  );
  const [dataVariables, setDataVariables] = useState(
    props.emailData.templates[0].data_variables
  );
  const [refreshKey, setRefreshKey] = useState(0);
  const editorBodyRef = useRef(null);
  const editorSubjectRef = useRef(null);
  const [selectedUserCount, setSelectedUserCount] = useState(0);

  const router = useRouter();
  const reviewEmailActions = new ReviewEmailActions();
  const [currentPurposeValue, setCurrentPurposeValue] = useState("");
  const [unsuccessfulEmailValues, setUnsuccessfulEmailValues] = useState({
    cc: "",
    subject: props.emailData.templates[0].subject,
    email_body: props.emailData.templates[0].email_body,
    language_iso_code: props.emailData.templates[0].language_iso_code
  });
  const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  function getFormFieldsName() {
    return {
      type: "template",
      master_template_id: "master_template_id",
      cc: "cc",
      subject: "subject",
      body: "email_body",
      default: "default",
      master_template_type: "master_template_type",
    };
  }
  const formFieldNames = getFormFieldsName();

  function editSubjectHtml(subject) {
    let new_subject = subject.replace(/(<([^>]+)>)/gi, "");
    new_subject = new_subject
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&gt;/g, ">")
      .replace(/&lt;/g, "<")
      .replace(/&rsquo;/g, "’")
      .replace(/&ouml;/g, "ö")
      .replace(/&oslash;/g, "ø")
      .replace(/&auml;/g, "ä")
      .replace(/&aring;/g, "å")
      .replace(/&aelig;/g, "æ")
    new_subject = new_subject.replace(/\n/g, " ");
    return new_subject.trim();
  }

  return (
    <Modal
      type="form"
      heading={TEXTS(t)[`${props.reviewKey}`]["heading"]}
      closeModal={async () => {
        if (props.from == "kanban")
          await clearRadioButtonSelection(
            props.setSelectedCards,
            props.activeTab,
            props.setActionBar
          );
        props.setUnsuccessfulEmailModal(false);
      }}
      content={
        <>
        <Formik
          initialValues={unsuccessfulEmailValues}
          validationSchema={UNSUCCESSFUL_EMAIL_VALIDATION}
          enableReinitialize
          onSubmit={(values) => {
            values.subject = editSubjectHtml(values.subject);
            if (props.reviewKey == "active_or_unsuccessful")
              send_unsuccessful_email({
                job_id: props.job_id,
                router: router,
                selectedCards: props.selectedCards,
                setActionBar: props.setActionBar,
                setSelectedCards: props.setSelectedCards,
                activeTab: props.activeTab,
                values: values,
                from: props.from,
                selectedValues: selectedValues,
                setUnsuccessfulEmailModal: props.setUnsuccessfulEmailModal,
                unsuccessful_candidates_token: props.unsuccessful_candidates_token
              });
            else if(props.reviewKey == "add_interview"){
              let action = props.addInterviewBar.action
               if(action.from == "manual_kanban_interview"){
                addManualKanbanInterview(action.values, action.router, action.setBtnPopup, action.setJobData || action.setInitialData, setShowLoader, action.current_interview_type, action.setFlagForRender, setDisabledSaveButton, action.props, props.setAddInterviewBar, props.addInterviewBar, values, props.setUnsuccessfulEmailModal);
              }else{
              addManualInterview(action.values, action.router, action.setBtnPopup, action.setInitialData, setShowLoader, action.current_interview_type, action.setFlagForRender, setDisabledSaveButton, action.from, props.setAddInterviewBar, props.addInterviewBar, values, props.setUnsuccessfulEmailModal);
              }
            }
            else {
              runAutomations({
                activeTab: props.activeTab,
                setJobData: props.setJobData,
                selectedCards: props.automationActions,
                setActionBar: props.setActionBar,
                router: router,
                job_id: props.job_id,
                setSelectedCards: props.setSelectedCards,
                filterData: props.filterData,
                from: props.from,
                values: values,
                reviewKey: props.reviewKey,
                setUnsuccessfulEmailModal: props.setUnsuccessfulEmailModal,
                selectedValues: selectedValues,
                setInitialData: props.setInitialData,
              });
            }
          }}
        >
          {(formik) => (
            <Form>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} removeplaceholder mt30`}
                  >
                    <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.master_template_id}`
                      )}>
                      <span className={`red-color`}>*</span>&nbsp; {t('label:purpose')}</label>
                    <FormikControl
                      control="select"
                      type="text"
                      formik={formik}
                      errorClass={PageStyle.Form__Error}
                      default={"0"}
                      disabled={false}
                      /* placeholder   =   {REVIEW_EMAIL.texts.purpose} */
                      className={`${PageStyle.Form__Input} thresholdmodl`}
                      name={
                        formFieldNames["type"] +
                        "." +
                        formFieldNames["master_template_id"]
                      }
                      options={reviewEmailActions.kanbanPurposeList(
                        props.emailData
                      )}
                      style={InputError(
                        formik,
                        `${formFieldNames.type}.${formFieldNames.master_template_id}`
                      )}
                      onChange={(option) => {
                        setCurrentPurposeValue(option.value);
                        reviewEmailActions.setUnsuccssfulModalData(
                          option,
                          formik,
                          formFieldNames,
                          setSubject,
                          setDataVariables,
                          setRefreshKey,
                          props.emailData.templates,
                          setUnsuccessfulEmailValues
                        );
                      }}
                    />
                  </div>
                  <div className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`}>
                      <label className={`${PageStyle.Form__Label}`}>{t('label:to')}</label>
                      {
                        <div className={PageStyle.SetupPopup__ToChips}>
                          <div>
                            <span className={`${PageStyle.SetupPopup__ToName} fw600`}>
                              {props.from == "kanban"
                                ? props.firstCandidateName ||
                                  getCandidateName(props.selectedCards)
                                : props?.data?.application.name}
                              {props.candidate_count > 1
                                ? ` + ${props.candidate_count - 1} More`
                                : ""}
                            </span>
                          </div>
                        </div>
                      }
                  </div>

                  <div
                   className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`}
                  >
                      <label className={`${PageStyle.Form__FloatingLabel}`} style= {InputText(formik, `${formFieldNames.cc}`)}>{t('label:cc')}</label>
                      <FormikControl
                        control="autosuggestInput"
                        errorClass={PageStyle.Form__Error}
                        formik={formik}
                        getSuggestionValue={
                          autosuggest_action.getSuggestionValue
                        }
                        inputProps={{
                          className: `AutosuggestOpenUp ${PageStyle.Form__Input}`,
                          formik: formik,
                          name: `${formFieldNames.cc}`,
                          onChange: (value, { newValue }) => {
                            formik.touched[`${formFieldNames.cc}`] = true;
                            formik.status
                              ? (formik.status[`${formFieldNames.cc}`] = "")
                              : "";
                            setValue(newValue);
                          },
                          placeholder: t('placeholder:search:type_name_search'),
                          style: InputError(formik, `${formFieldNames.cc}`),
                          value: value,
                        }}
                        onSuggestionsClearRequested={
                          autosuggest_action.onSuggestionsClearRequested
                        }
                        onSuggestionsFetchRequested={
                          autosuggest_action.onSuggestionsFetchRequested
                        }
                        onSuggestionSelected={(event, { suggestion }) => {
                          if (suggestion.user_attributes.email.length > 0) {
                            setValue("");
                            setSelectedValues;
                            autosuggest_action.onSuggestionSelectionEmail(
                              {
                                email: suggestion.user_attributes.email,
                                name_initials:
                                  suggestion.user_attributes.name_initials,
                                name: suggestion.user_attributes.name,
                                photo_url: suggestion.user_attributes.photo_url,
                              },
                              selectedValues,
                              setSelectedValues,
                              setValue,
                              setSelectedUserCount,
                              formik
                            );
                          }
                        }}
                        renderSuggestion={autosuggest_action.renderSuggestion}
                        shouldRenderSuggestions={
                          autosuggest_action.shouldRenderSuggestions
                        }
                        suggestions={suggestion}
                        type="email"
                      />
                      <div className={`Dpflexonly Flexflow`}>
                      {selectedValues.map(function (element, index) {
                        return (
                          <div
                            className={`Sharecv emailchipsspace ${PageStyle.Tagrow}`}
                            key={index}
                          >
                            <div className={PageStyle.Tagrow__Tags}>
                              {element?.photo_url ? (
                                <img
                                  src={element?.photo_url}
                                  className="JobImageSmall"
                                />
                              ) : (
                                element.name_initials && (
                                  <div className={PageStyle.Tagrow__Prefix}>
                                    {element.name_initials}
                                  </div>
                                )
                              )}

                              <p className={`ml6`}>
                                {element.name || element.email}
                              </p>
                              <button
                                type="button"
                                className={PageStyle.Tagrow__Cancel}
                                onClick={(event) =>
                                  autosuggest_action.removeSelectedValues(
                                    event,
                                    selectedValues,
                                    setSelectedValues,
                                    setSelectedUserCount
                                  )
                                }
                                data-index={index}
                              >
                                <Close/>
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol} mt30`}
                  >
                    <label className={`${FormModalStyle.Modal__Container__ContentSection__Block__Heading} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `${formFieldNames.subject}`)}>
                    {t('label:subject')}</label>
                    <FormikControl
                      id="email_template_subject"
                      key={refreshKey}
                      apiKey={process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
                      control="customEditor"
                      formik={formik}
                      onInit={(evt, editor) =>
                        (editorSubjectRef.current = editor)
                      }
                      textareaName={`${formFieldNames.subject}`}
                      identifierClass="emailTemplateSubject"
                      style={InputError(formik, `${formFieldNames.subject}`)}
                      value={formik.values[`${formFieldNames.subject}`]}
                      onEditorChange={(value, editor) => {
                        formik.status
                          ? (formik.status[`${formFieldNames.subject}`] = "")
                          : "";
                        formik.setFieldValue(
                          `${formFieldNames.subject}`,
                          value
                        );
                      }}
                      init={{
                        height: 50,
                        resize: false,
                        menubar: false,
                        plugins: [
                          "advlist autolink lists link image charmap print preview anchor",
                          "searchreplace visualblocks code fullscreen",
                          "insertdatetime media table paste help wordcount autoresize  noneditable",
                        ],
                        toolbar: "tokens",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        newline_behavior: "block",
                        noneditable_regexp: /\{\{[^\}]+\}\}/g,
                        setup: (editor) => {
                          editor.ui.registry.addMenuButton("tokens", {
                            text: t('label:data_tags'),
                            tooltip: t('label:insert_token'),
                            fetch: (callback) => {
                              var items = subject.map((subject) => {
                                return {
                                  type: "menuitem",
                                  text: subject.text,
                                  onAction: () => {
                                    editor.insertContent(subject.value);
                                  },
                                };
                              });
                              callback(items);
                            },
                          });
                          editor.on("keydown", function (e) {
                            if (e.keyCode == 13) {
                              e.preventDefault();
                            }
                          });
                        },
                        paste_preprocess: function (plugin, args) {
                          args.content = args.content.replace(
                            /(<([^>]+)>)/gi,
                            ""
                          );
                        },
                      }}
                    />
                  </div>
                  <div className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`}>
                    <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `${formFieldNames.body}`)}> {t('label:email_body')}</label>
                    <FormikControl
                      id="email_template_body"
                      key={refreshKey}
                      control="customEditor"
                      formik={formik}
                      onInit={(evt, editor) => (editorBodyRef.current = editor)}
                      textareaName={`${formFieldNames.body}`}
                      identifierClass="emailTemplateBody"
                      style={InputError(formik, `${formFieldNames.body}`)}
                      value={formik.values[`${formFieldNames.body}`]}
                      onEditorChange={(value) => {
                        formik.status
                          ? (formik.status[`${formFieldNames.body}`] = "")
                          : "";
                        formik.setFieldValue(`${formFieldNames.body}`, value);
                      }}
                      init={{
                        height: 500,
                        menubar: false,
                        resize: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "image",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "help",
                          "wordcount",
                          "noneditable",
                        ],
                        toolbar:
                          "undo redo | blocks | " +
                          "bold italic backcolor | link | alignleft aligncenter " +
                          "alignright alignjustify | tokens",

                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        noneditable_regexp: /\{\{[^\}]+\}\}/g,
                        allow_html_in_named_anchor: true,
                        setup: (editor) => {
                          editor.ui.registry.addMenuButton("tokens", {
                            text: t('label:data_tags'),
                            tooltip: t('label:insert_token'),
                            fetch: (callback) => {
                              var items = dataVariables.map((dataVariable) => {
                                return {
                                  type: "menuitem",
                                  text: dataVariable.text,
                                  onAction: () => {
                                    editor.insertContent(dataVariable.value);
                                  },
                                };
                              });
                              callback(items);
                            },
                          });
                        },
                      }}
                    />
                  </div>
                <div className={`${FormModalStyle.Modal__Container__ButtonSection}`}>
                    <Button
                      buttonstyle={PageStyle.secondarybtnborder}
                      type="button"
                      onClick={async () => {
                        if (props.from == "kanban")
                          await clearRadioButtonSelection(
                            props.setSelectedCards,
                            props.activeTab,
                            props.setActionBar
                          );
                        props.setUnsuccessfulEmailModal(false);
                      }}
                    >
                     {t('button:cancel')}
                    </Button>
                    <Button buttonstyle={PageStyle.primarybtn} disabled={disabledSaveButton} type="submit">
                    {t('button:send')}
                    </Button>
                </div>
            </Form>
          )}
        </Formik>
        {showLoader && <Loading/>}
        </>
      }
    />
  );
}
